import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=5f38ea40&scoped=true&"
import script from "./Institutions.vue?vue&type=script&lang=js&"
export * from "./Institutions.vue?vue&type=script&lang=js&"
import style0 from "./Institutions.vue?vue&type=style&index=0&id=5f38ea40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f38ea40",
  null
  
)

export default component.exports